package it.neckar.processStates

/**
 * The phase of a process state
 */
enum class ProcessStatePhase {

  Paused,

  Rejected,

  /**
   * Currently untouched - nothing has been done yet.
   */
  Untouched,

  /**
   * The element is currently in progress (work is being done)
   */
  InProgress,

  Waiting,

  /**
   * The element is done
   */
  Done,

  ;

  /**
   * Whether work on the element has ended — [Done] and [Paused].
   * [Paused] counts as finished, so [onlyUnfinished] drops a paused element just like a done one.
   */
  val isFinished: Boolean
    get() = this == Paused || this == Done

  /**
   * Whether the element was not carried through — [Rejected] and [Paused].
   * [Paused] is the one phase that is [isFinished] and [isRejected] at the same time.
   */
  val isRejected: Boolean
    get() = this == Paused || this == Rejected
}
